import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=a52288bc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=a52288bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52288bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52288bc')) {
      api.createRecord('a52288bc', component.options)
    } else {
      api.reload('a52288bc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=a52288bc&scoped=true&", function () {
      api.rerender('a52288bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2um1A7Cx97CKh/JS/comp/CookieBox.vue"
export default component.exports